import './ConcreteButton.css';
import React from "react";
import concreteButton from '../../assets/images/concreteButton.jpg'
import arrow from "../../assets/images/arrow.png"


function ConcreteButton(props) {

    return (
        <div class={"concreteButton" + (props.isSmall ? " concreteButtonSmall" : "")}>
            <a className="buttonHref" href={props.href} rel="noreferrer">
            <img className={"concreteButtonBackground" + (props.isSmall ? " concreteButtonBackgroundSmall" : "")} src={concreteButton} alt="black concrete pattern button background" />
            <p className={"buttonLinkText" + (props.isSmall ? " buttonLinkTextSmall" : "")}> {props.text} </p>
            <img className={"blackArrowImg" + (props.isSmall ? " blackArrowImgSmall" : "")} src={arrow} alt="black arrow that when clicked will open a new page"></img>
            </a>
        </div>
    )
}

export default ConcreteButton;